import React from 'react';
import { NavLink } from 'react-router-dom';
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';

const images = [
    require('./../../images/gallery/portrait/caliopel.jpg'),
    require('./../../images/gallery/portrait/coincaII.jpg'),
]

var bnr1 = require('./../../images/background/line.png');

class About4 extends React.Component {
    
    componentDidMount(){
        function loadScript(src) {
           
          return new Promise(function(resolve, reject){
            var script = document.createElement('script');
            script.src = src;
            script.addEventListener('load', function () {
              resolve();
            });
            script.addEventListener('error', function (e) {
              reject(e);
            });
            document.body.appendChild(script);
            document.body.removeChild(script);
          })
        };
 
      loadScript('./assets/js/masonary.js');
      
    };
    
    render() {
        const options = {
            loop:true,
            autoplay:true,
            autoplayTimeout:3000,
            margin:30,
            nav:false,
            navText: ['<i class="fa fa-angle-left"></i>', '<i class="fa fa-angle-right"></i>'],
            items:1,
            dots: true
        };
        return (
            <>
                <div className="section-full p-t30 p-b80 bg-white inner-page-padding">
                    <div className="container">
                        <div className="section-content ">
                            <div className="row">
                                <div className="col-md-5 col-sm-6">
                                    <div className="m-about ">
                                        <OwlCarousel className="owl-carousel about-us-carousel" {...options}>
                                            {images.map((item, index) => (
                                                <div className="item" key={index}>
                                                    <div className="ow-img">
                                                    <NavLink to="/about"><img src={item.default} alt=""/></NavLink>
                                                    </div>
                                                </div>
                                            ))}
                                        
                                        </OwlCarousel>
                                        
                                    </div>
                                </div>
                                <div className="col-md-7 col-sm-6">
                                    <div className="m-about-containt text-black p-t80">
                                        <div className="m-about-years bg-moving" style={{backgroundImage:"url(" + bnr1.default + ")"}}>
                                            <span className="text-primary large-title">7</span>
                                            <span className="large-title-info">Años de Experiencia</span>
                                        </div>
                                        <h3 className="font-weight-600">Mejorar la calidad de vida con un enfoque unificado integrado.</h3>
                                        <p>Promovemos la búsqueda y creación de ideas creativas e innovadoras, para que nuestras obras estén acorde a los nuevos cambios constructivos.</p>
                                        <div className="author-info p-t20">
                                            {/*<div className="author-signature">
                                                <img src={require('./../../images/Signature+Black.png').default} alt="Signature" width={150} />
                                            </div>*/}
                                            <div className="author-name">
                                                <h4 className="m-t0">Edward Castillo</h4>
                                                <p>Ingeniero &amp; Fundador</p>
                                            </div>
                                            <NavLink to="/contactus" className="site-button btn-effect m-b15" reloadDocument={true}><span>Contactenos</span></NavLink>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
};

export default About4;